<template>
  <div class="input-text-container">
    <input :class="uppercase ? 'uppercase' : ''" :maxlength="maxlength" :type="type" :value="currentValue" @input="currentValue = $event.target.value" autocomplete="new-password"/>
    <span class="input-error" v-if="activate_required">{{$_('field_required')}}</span>
    <span class="input-error">{{customText}}</span>
  </div>
</template>

<script>
export default {
  name: 'InputText',
  data() {
    return {
      activate_required: false,
      currentValue: '',
      customText: ''
    }
  },
  props: {
    type: {
      type: String,
      default: 'text'
    },
    required: {
      type: Boolean,
      default: false
    },
    maxlength: {},
    name: {
      type: String,
      default: ''
    },
    val: {},
    reset: {
      type: Boolean,
      default: false
    },
    uppercase: {
      type: Boolean,
      default: false,
    }
  },
  mounted() {

   
    if(this.$props.val !== undefined && this.$props.val !== '') {
      this.currentValue = this.$props.val
    } else {
      this.currentValue = ''
    }
  },
  computed: {
    getVal() {
      return this.$props.val
    },
    getReset() {
      return this.$props.reset;
    }
  },
  watch: {
    currentValue(val) {
      this.$emit('typing', val); 
    },
    getVal(val) {
      this.currentValue = val
    },
    getReset(val) {
      if(val) {
        this.currentValue = '';
      }
    }
  }
};
</script>

<style scoped>

</style>